import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Typography } from '@optimus-web/core';
import { SpacedForwardSlash } from '@mews-commander/ui';

interface SelectedCountProps {
    selectedCount: number;
    totalCount: number;
}
export const SelectedCount = ({ selectedCount, totalCount }: SelectedCountProps) => (
    <Typography textStyle="bodySmallStrong" variant="secondary" as="div">
        {selectedCount}
        {SpacedForwardSlash}
        {totalCount}
        {UnicodeEntity.NoBreakSpace}
        <LocalizedText textKey={TextKey.Selected} firstLowerCase />
    </Typography>
);
